module.exports = __webpack_public_path__ + "14a3a3137dabfb3af9822c5fabe1dbb9.woff";